import { NXDataSourcePrime } from '../../../core/services/dataSource/NXDataSourcePrime';
import { Apollo } from 'apollo-angular';
import { Task } from 'src/app/rent-module/shared/entities/task/task';
import { environment } from 'src/environments/environment';
import * as fromGraphQl from './primeGraphql';


export class PrimeToursPlannerTaskListDataSource extends NXDataSourcePrime<Task> {
  constructor(apollo: Apollo, private changeDetectorRef: any) {
    super(apollo, fromGraphQl.TOUR_PLANNER_TASK_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.TourPlannerTasksQueryResponse): void {
    super.setSubject(
      data.tasksForPlanning ? Task.createTasks(data.tasksForPlanning?.content) : [],
      data.tasksForPlanning ? data.tasksForPlanning.totalElements : 0
    );
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
    }, 100);
  }

  loadTasks(variables: any): void {
    this.subscribeToQuery(variables);
  }

  stopPolling(): void {
    this.queryRef?.stopPolling();
  }

  startPolling(): void {
    this.queryRef?.startPolling(environment.pollingIntervall);
  }
}
